import React from 'react';

// Default value is defined in SettingsOptionsContextProvider
export const SettingsOptionsContext = React.createContext({});
